import React from 'react'

export type BlockFooterUsersIconProps = {
  className: string
}

export const BlockFooterUsersIcon: React.FC<BlockFooterUsersIconProps> = ({
  className,
}) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="26" height="26" rx="4" fill="#373AF5" />
      <path
        d="M17 21V19.3333C17 18.4493 16.6313 17.6014 15.9749 16.9763C15.3185 16.3512 14.4283 16 13.5 16H6.5C5.57174 16 4.6815 16.3512 4.02513 16.9763C3.36875 17.6014 3 18.4493 3 19.3333V21"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 12C12.433 12 14 10.433 14 8.5C14 6.567 12.433 5 10.5 5C8.567 5 7 6.567 7 8.5C7 10.433 8.567 12 10.5 12Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 21V19.2964C22.9993 18.5415 22.7044 17.8082 22.1614 17.2115C21.6184 16.6149 20.8581 16.1887 20 16"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 5C16.8582 5.19898 17.6188 5.65096 18.162 6.28467C18.7052 6.91838 19 7.69778 19 8.5C19 9.30222 18.7052 10.0816 18.162 10.7153C17.6188 11.349 16.8582 11.801 16 12"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
